
import { HelpService } from '@/services'
import { Component, Vue, Ref } from 'vue-property-decorator'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import TableList from '../components/help/article_types_table.vue'

@Component({
    name: 'bulletin-list',
    components: {
        ScrollTo,
        TableList
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private list: any[] = []
    private isLoading = true

    private mounted() {
        this.getList()
    }

    /** 获取文章分类列表 */
    private async getList() {
        this.isLoading = true
        const result = await HelpService.getArticleTypes({})
        if (result.status === 200) {
            this.pageTotal = result.data.length
            this.list = result.data
        }
        this.isLoading = false
    }

    /** 删除文章分类 */
    private async deleteType(type: any) {
        const params = { id: type.id }
        const result = await HelpService.deleteArticleType(params)
        if (result.status === 200) {
            this.list.splice(this.list.indexOf(type), 1)
            --this.pageTotal
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    // 分页
    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getList)
    }

    // 删除
    private onDelete(type: any) {
        this.$confirm('你正在删除文章分类, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteType(type)
        })
    }

    openUrl(url: string) {
        window.open('/setting/help' + url)
    }
}
